/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EodMelcoEodModelsEodMachineDetail,
    EodMelcoEodModelsEodMachineDetailFromJSON,
    EodMelcoEodModelsEodMachineDetailFromJSONTyped,
    EodMelcoEodModelsEodMachineDetailToJSON,
    EodMelcoModelsCustomWarning,
    EodMelcoModelsCustomWarningFromJSON,
    EodMelcoModelsCustomWarningFromJSONTyped,
    EodMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail
 */
export interface EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail {
    /**
     * 
     * @type {Array<EodMelcoEodModelsEodMachineDetail>}
     * @memberof EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail
     */
    list: Array<EodMelcoEodModelsEodMachineDetail>;
    /**
     * 
     * @type {Array<EodMelcoModelsCustomWarning>}
     * @memberof EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail
     */
    warning_list?: Array<EodMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail
     */
    total: number;
}

export function EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetailFromJSON(json: any): EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail {
    return EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetailFromJSONTyped(json, false);
}

export function EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EodMelcoEodModelsEodMachineDetailFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EodMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetailToJSON(value?: EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EodMelcoEodModelsEodMachineDetailToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EodMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


